import { sampleQueryKeys } from '@/config/queryKeys';
import { fetchSamplesQcSummary } from '@/services/samples';
import type { SampleQcSummary } from '@/types';
import { useQuery } from '@tanstack/react-query';

const QC_SUMMARY_STALE_TIME = 60 * 1000;

/**
 * Org-wide sample QC tallies. Scope-wide by design: the counts do not follow the samples
 * grid's filter or pagination state.
 */
export function useSamplesQcSummary(orgId: string | undefined, enabled = true) {
  return useQuery<SampleQcSummary>({
    queryKey: sampleQueryKeys.qcSummary(orgId ?? ''),
    queryFn: () => fetchSamplesQcSummary(orgId ?? ''),
    enabled: Boolean(orgId) && enabled,
    staleTime: QC_SUMMARY_STALE_TIME,
  });
}
